export default __webpack_public_path__ + "static/media/Vambrace of Crimson Slaughter (nm).7eb81c80.jpg";